import { Select } from "antd";
import { useCallback } from "react";

export const DropdownSelector = <T extends Object>({
  options,
  value,
  onChange,
  group,
}: {
  options: { value: T; label: string }[];
  value: T | null;
  onChange: (value: T) => void;
  group: string;
}) => {
  const selectorChange = useCallback(
    (value: T) => {
      const newDiv = document.createElement("div");
      newDiv.id = "shadow_dom";
      document.querySelector(".excalidraw-container")!.appendChild(newDiv);
      setTimeout(() => {
        const divToRemove = document.getElementById("shadow_dom")!;

        document
          .querySelector(".excalidraw-container")!
          .removeChild(divToRemove);
      }, 0);

      onChange(value);
    },
    [onChange],
  );
  return (
    <>
      <Select
        size="small"
        defaultValue={value}
        style={{ width: 180 }}
        onChange={selectorChange}
        options={options}
      />
    </>
  );
};
